var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-home"},[_c('oneBanner'),_c('twoAdvantages'),_c('threeSwiper'),_c('fourOnlineOffline'),_c('fiveLatestNews'),_c('sixCompanyIcon'),_c('sevenReservation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }